import Vue from 'vue';

import {
  dateprintString,
  dateprintDefault,
  // dateprintAdd,
  dateprintServer,
  dateprintFormatDistanceToNow,
} from '@/utils/dateprint';

Vue.filter('dateprint_string', (value) => dateprintString(value));
Vue.filter('dateprint_default', (value) => dateprintDefault(value));
// Vue.filter('dateprint_add', (value, duration = 45) => dateprintAdd(value, duration));
Vue.filter('dateprint_server', (value, duration = 45) => dateprintServer(value, duration));
Vue.filter('dateprint_from_now', (value) => dateprintFormatDistanceToNow(value));
